import { zoomReducerKey } from './ZoomConstants';


export function zoomBranch (state) {
  return state.get(zoomReducerKey);
}

export function zoomValueByKey (state, ownProps) {
  return zoomBranch(state).get(ownProps.zoomKey);
}
